import { apiProxyRequest } from "Api/apiProxyRequest";

import type { Invoice } from "../types";

export const getInvoiceRequest = (
  billingProfileId: string,
  invoiceId: string
) => {
  return apiProxyRequest<Invoice>(
    `/billing/profiles/${billingProfileId}/invoices/${invoiceId}`
  );
};
